import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "a",
  "use": "a-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol viewBox=\"0 0 100 100\" id=\"a\"><path class=\"cls-1\" d=\"M77 96.93l-9.38-26.17h-36l-9.25 26.17H6.13L41.39 2.31h16.75L93.4 96.93zM63.56 57.48l-8.83-25.65q-1-2.58-2.68-8.12t-2.35-8.12a145.2 145.2 0 0 1-5.09 17.33L36.1 57.48z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/a.svg
// module id = tfbz
// module chunks = 1